import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';

@Component({
    selector: 'app-landing-index',
    templateUrl: './landing-index.component.html',
    styleUrls: ['./landing-index.component.scss'],
    standalone: false
})
export class LandingIndexComponent implements OnInit {
    constructor(
        private translocoService: TranslocoService,
        private globalEmittersService: GlobalEmittersService
    ) {}

    ngOnInit(): void {
        let activelang = navigator.language.split('-');
        let res = this.translocoService.getAvailableLangs().some((x) => x == activelang[0]);
        if (res === true) {
            this.translocoService.setActiveLang(activelang[0]);
        }
        this.globalEmittersService.isLanguageSetUp.next(true);
    }
}
